import { DesignAtomsVdpModel } from "../models/design-atoms-vdp.model";
import type { IDesignAtomsVariables, IDesignAtomsVdpModel } from "../types/design-atoms.types";
import type { InnerDatasetInterfaces } from "../types/inner-dataset-interfaces";
import type { IDataSet, IRawSurfacesData } from "../types/table.types";

export default class DesignAtomsService {
  private apigateway: string | null;
  private stateId: string | null;
  private tenantId: string | null;
  private ownerId: string | null;
  private token: string | null;

  constructor(options: {
    apigateway: string | null,
    stateId: string | null,
    token: string | null,
    tenantId: string | null,
    userId: string | null
  }) {
    this.apigateway = options.apigateway;
    this.stateId = options.stateId;
    this.token = options.token;
    this.tenantId = options.tenantId;
    this.ownerId = options.userId;
  }

  public async getVariables(): Promise<IDesignAtomsVariables> {
    const method = "GET";
    const url = new URL(String(this.apigateway));
    url.pathname = `/api/atoms/v1/designs/${this.stateId}/variables`;
    url.searchParams.set('tenantId', String(this.tenantId));
    // url.searchParams.set('privateStorageOwner', this.ownerId);

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`,
      },
    }).then((res) => res.json()).catch(console.error);
  }

  public async getVdpData(): Promise<InnerDatasetInterfaces.DesignAtomsDataset> {
    const method = "GET";
    const url = new URL(String(this.apigateway));
    url.pathname = `/api/atoms/v1/designs/${this.stateId}/vdp-data`;
    url.searchParams.set('privateStorageOwner', String(this.ownerId));
    url.searchParams.set('tenantId', String(this.tenantId));

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`,
      },
    }).then((res) => res.json()).catch(console.error);
  }

  public async putVdp(dataset: IDataSet[], surfaceData: IRawSurfacesData): Promise<void> {
    const method = "PUT";
    const url = new URL(String(this.apigateway));
    url.pathname = `/api/atoms/v1/designs/${this.stateId}/vdp-data`;
    url.searchParams.set('privateStorageOwner', String(this.ownerId));
    url.searchParams.set('tenantId', String(this.tenantId));

    const vdpDataSet = this.processDatasetToDesignAtomsModel(dataset, surfaceData);

    const body = {
      vdpDataSet,
      // TODO: Add vdpItemsData if needed
      // vdpItemsData: {},
    };

    await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`,
      },
      body: JSON.stringify(body),
    }).catch(console.error);
  }

  private processDatasetToDesignAtomsModel(dataset: IDataSet[], surfaceData: IRawSurfacesData): IDesignAtomsVdpModel {
    const model = new DesignAtomsVdpModel(dataset, surfaceData);
    model.addSurfacesData();
    model.setSurfaceBinding();
    model.setData();
    const vdpDataSet = model.serialize();
    return vdpDataSet;
  }
};